import React from 'react';

import cx from 'classnames';

import s from './index.module.css';
import { IWrapperProps } from './types';

function Wrapper({ children, className, ...props }: IWrapperProps) {
  return (
    <div className={cx(s.subheadline, className, 'custom-left-subheadline')} {...props}>
      <span className={cx(s.subheadlineBorder, 'custom-left-subheadline-border')} />
      {children}
    </div>
  );
}

export default Wrapper;
